import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import style from './asideBlogSection.module.css'
import Img from 'gatsby-image';

const AsideBlogSection = () => {
    const data = useStaticQuery(graphql`
       query {
            allContentfulWebpageSection {
              edges {
                node {
                  id
                  contentfulid
                  images {
                    fluid(resizingBehavior: FILL) {
                        ...GatsbyContentfulFluid
                    }
                  }
                  content {
                    body1
                  }
                }
              }
            }
          }
          
        `
    )
    //get aside section
    const sections = data.allContentfulWebpageSection.edges.reduce((all, one) => {
        const newAll = { ...all };
        newAll[one.node.contentfulid] = {
          ...one.node.childContentfulWebpageSectionContentJsonNode,
          images: one.node.images ? one.node.images : undefined,
          bio: one.node.content ? one.node.content.body1 : undefined,
        };
        return newAll;
      }, {});

      const bio = sections.sectionAsideBlogpost.bio
return( 
    <aside className={style.asideSection}>
        <div className={style.asideContent}>
            <div>
                <Img fluid={sections.sectionAsideBlogpost.images[0].fluid} alt={'Jessica'}></Img>
            </div>
            <p>{bio}</p>
        </div>
    </aside>
)
}
export default AsideBlogSection;